var map = {
	"./DSCF5597.jpg": 7430,
	"./DSCF5604.jpg": 1099,
	"./DSCF5621.jpg": 4605,
	"./DSCF5636.jpg": 9364,
	"./DSCF5680.jpg": 5951,
	"./DSCF5728.jpg": 7951,
	"./DSCF5756.jpg": 9363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1260;